export const removeSpecialCharacters = (val: string | undefined) => {
  if (val) return val.replace(/[^a-zA-Z0-9]/g, '');
  return undefined;
};
